export default {
  overview: 'Ringkasan',
  specification: 'Spesifikasi',
  review: 'Ulasan',
  compare: 'Bandingkan',
  other_products: 'Produk Lainnya',
  price_info: 'Harga adalah kisaran rata-rata pasar, setiap toko dapat berbeda beda.',
  brand: 'Merk',
  color: 'Warna',
  new: 'Baru',
};
